import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export interface HousingStockGrowthRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  total_housing_units: number;
  bps_total_units: number;
  housing_stock_growth_if_permits_built_instantly: number;
}

export function useHousingStockGrowthData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<HousingStockGrowthRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false);
      setData([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_housing_stock_growth')
      .select('*')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .order('year', { ascending: false })
      .limit(1)
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching housing stock growth data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          setData(supabaseData || []);
          // Log the latest record for the selected city
          const latest = (supabaseData || [])[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  Housing Stock Growth: ${latest.housing_stock_growth_if_permits_built_instantly?.toFixed(2)}%`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 